var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(0 -1 1 0 1.034 -1617.034)",
    gradientUnits: "userSpaceOnUse",
    x1: -1998.806,
    x2: -1715.23,
    y1: 122.498,
    y2: 406.074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdbed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcfdee"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m61.527 38.752c-87.955 52.949-91.432 349.888 54.326 228.181 70.107-58.54 79.911 23.525 126.151-18.696 13.2-12.053 24.132-38.876 42.863-33.3 74.441 22.162-41.076 101.576-64.316 139.945-38.011 62.754 26.564 130.938 96.264 119.919 41.469-6.556 57.057-50.313 117.016-39.647 41.828 7.441 88.46-25.144 76.166-64.754-18.089-58.281-85.951-102.112-79.451-167.851 5.229-52.883-29.358-132.635-70.312-139.415-65.01-10.763-137.203 122.424-174.23 21.52-14.057-38.306-57.884 1.337-72.488-17.85-14.95-19.645-26.954-43.123-51.989-28.052z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m446.391 131.928h-380.782c-5.523 0-10 4.477-10 10v250.076c0 5.523 4.477 10 10 10h139.591v61.593h-26.359c-2.761 0-5 2.239-5 5v10.158c0 2.761 2.239 5 5 5h154.318c2.761 0 5-2.239 5-5v-10.158c0-2.761-2.239-5-5-5h-26.359v-61.593h139.591c5.523 0 10-4.477 10-10v-250.076c0-5.523-4.477-10-10-10zm-173.431 292.198c0 5.523-4.477 10-10 10h-13.92c-5.523 0-10-4.477-10-10v-22.122h33.92z",
    fill: "#2626bc",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m306.8 369.736v77.76h-101.6v-77.76h33.84v30.39c0 5.523 4.477 10 10 10h13.92c5.523 0 10-4.477 10-10v-30.39z",
    fill: "#b7c5ff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9fb0fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m239.04 400.126c0 .64.06 1.27.18 1.88h-34.02v-32.27h33.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.8 369.736v32.27h-34.02c.12-.61.18-1.24.18-1.88v-30.39z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m456.39 117.926v250.08c0 5.52-4.48 10-10 10h-380.78c-5.52 0-10-4.48-10-10v-250.08c0-5.52 4.48-10 10-10h380.78c5.52 0 10 4.48 10 10z",
    fill: "#8399fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.96 107.926c-.45 12.04-1.75 25.62-4.78 38.06-17.42 71.49-69.46 82.13-76.41 83.24-.51.08-1.03.08-1.54 0-6.95-1.11-58.99-11.75-76.41-83.24-3.03-12.44-4.33-26.02-4.78-38.06z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.798 302.922h-207.596c-5.523 0-10-4.477-10-10v-27.92c0-5.523 4.477-10 10-10h207.597c5.523 0 10 4.477 10 10v27.92c-.001 5.523-4.478 10-10.001 10z",
    fill: "#ffa8cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.798 235.193h-207.596c-5.523 0-10-4.477-10-10v-27.92c0-5.523 4.477-10 10-10h207.597c5.523 0 10 4.477 10 10v27.92c-.001 5.523-4.478 10-10.001 10z",
    fill: "#ffa8cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316 187.276c-22.39 34.71-53.93 41.1-59.23 41.95-.51.08-1.03.08-1.54 0-5.3-.85-36.84-7.24-59.23-41.95z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 170.62,
    cy: 211.233,
    fill: "#ffdbed",
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.08,
    cy: 211.233,
    fill: "#ffdbed",
    r: 6.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffc4df"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 227.54,
    cy: 211.233,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 211.233,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.46,
    cy: 211.233,
    r: 6.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 312.92,
    cy: 211.233,
    fill: "#ffdbed",
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.38,
    cy: 211.233,
    fill: "#ffdbed",
    r: 6.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "m446.391 378.004h-380.782c-5.523 0-10-4.477-10-10v-38.367h400.783v38.367c-.001 5.523-4.478 10-10.001 10z",
    fill: "#d2deff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m332.304 49.303c-12.769.705-47.964.924-73.631-15.293-1.635-1.033-3.709-1.033-5.345 0-25.667 16.218-60.862 15.998-73.631 15.293-2.739-.151-5.086 1.927-5.261 4.664-.756 11.836-1.868 42.363 4.383 68.013 17.423 71.496 69.465 82.134 76.412 83.245.512.082 1.027.082 1.539 0 6.946-1.11 58.988-11.749 76.412-83.245 6.251-25.65 5.14-56.178 4.383-68.013-.176-2.737-2.522-4.815-5.261-4.664z",
    fill: "#ff5ba8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.001 184.994c-10.129-2.389-44.737-14.346-57.751-67.749-3.872-15.887-4.525-34.615-4.372-47.769 18.106-.466 41.464-3.539 62.122-14.018 20.658 10.479 44.016 13.552 62.122 14.018.153 13.153-.5 31.882-4.372 47.769-13.016 53.41-47.63 65.364-57.749 67.749z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 55.459c20.658 10.479 44.016 13.552 62.122 14.018.153 13.153-.5 31.882-4.372 47.769-13.016 53.41-47.63 65.363-57.749 67.749z",
    fill: "#ffa8cf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m271.06 116.402c-2.761 0-5-2.239-5-5v-15.512c0-5.547-4.513-10.06-10.06-10.06s-10.061 4.513-10.061 10.06v15.512c0 2.761-2.239 5-5 5s-5-2.239-5-5v-15.512c0-11.061 8.999-20.06 20.061-20.06 11.061 0 20.06 8.999 20.06 20.06v15.512c0 2.761-2.238 5-5 5z",
    fill: "#d2deff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m271.45 157.746h-30.9c-5.523 0-10-4.477-10-10v-26.443c0-5.523 4.477-10 10-10h30.899c5.523 0 10 4.477 10 10v26.443c.001 5.523-4.477 10-9.999 10z",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256 145.961c-3.114 0-5.638-2.524-5.638-5.638v-5.477c0-3.114 2.524-5.638 5.638-5.638 3.114 0 5.638 2.524 5.638 5.638v5.477c0 3.114-2.524 5.638-5.638 5.638z",
    fill: "#2d58e0"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m333.159 459.756h-154.318c-2.761 0-5-2.239-5-5v-10.158c0-2.761 2.239-5 5-5h154.318c2.761 0 5 2.239 5 5v10.158c0 2.761-2.238 5-5 5z",
    fill: "#d2deff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m446.392 102.928h-81.37c-2.762 0-5 2.239-5 5s2.238 5 5 5h81.37c2.757 0 5 2.243 5 5v206.708h-390.784v-206.708c0-2.757 2.243-5 5-5h106.256c.589 3.458 1.281 6.886 2.098 10.237 7.609 31.229 22.428 55.073 44.041 70.87 16.743 12.237 32.123 15.438 36.437 16.128.518.083 1.039.125 1.562.125.521 0 1.041-.042 1.558-.124 4.315-.69 19.695-3.892 36.438-16.128 21.613-15.797 36.432-39.641 44.041-70.87 6.404-26.28 5.292-57.369 4.517-69.515-.349-5.45-5.063-9.644-10.526-9.338-13.185.727-46.476.77-70.686-14.528-3.246-2.052-7.439-2.051-10.686 0-24.21 15.298-57.493 15.256-70.686 14.528-5.438-.292-10.178 3.888-10.526 9.338-.582 9.111-1.353 28.878 1 49.279h-104.838c-8.271 0-15 6.729-15 15v250.076c0 8.271 6.729 15 15 15h134.592v51.593h-21.359c-5.514 0-10 4.486-10 10v10.158c0 5.514 4.486 10 10 10h154.318c5.514 0 10-4.486 10-10v-10.158c0-5.514-4.486-10-10-10h-21.359v-28.901c0-2.761-2.238-5-5-5s-5 2.239-5 5v28.901h-91.6v-51.593h23.84v17.122c0 8.271 6.729 15 15 15h13.92c8.271 0 15-6.729 15-15v-17.122h168.432c8.271 0 15-6.729 15-15v-250.078c0-8.271-6.729-15-15-15zm-266.971-48.633c14.146.782 49.931.779 76.58-16.059 26.645 16.835 62.423 16.838 76.574 16.059.746 11.695 1.824 41.565-4.252 66.501-16.741 68.697-66.701 78.589-72.304 79.491-5.642-.902-55.602-10.794-72.343-79.491-6.077-24.941-4.997-54.821-4.255-66.501zm153.745 400.46h-154.325v-10.158h154.318zm-65.206-54.629c0 2.757-2.243 5-5 5h-13.92c-2.757 0-5-2.243-5-5v-17.122h23.92zm183.432-32.122c0 2.757-2.243 5-5 5h-380.784c-2.757 0-5-2.243-5-5v-33.368h390.783v33.368z",
    fill: "#2626bc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m359.798 300.922h-207.596c-5.523 0-10-4.477-10-10v-27.92c0-5.523 4.477-10 10-10h207.597c5.523 0 10 4.477 10 10v27.92c-.001 5.523-4.478 10-10.001 10z",
    fill: "#ffa8cf"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m158.815 181.188c0-9.161-7.453-16.613-16.613-16.613s-16.613 7.453-16.613 16.613c0 4.518 1.818 8.615 4.755 11.613-2.936 2.998-4.755 7.095-4.755 11.613 0 2.761 2.239 5 5 5s5-2.239 5-5c0-3.646 2.967-6.613 6.613-6.613s6.613 2.967 6.613 6.613c0 2.761 2.239 5 5 5s5-2.239 5-5c0-4.518-1.818-8.615-4.755-11.613 2.937-2.998 4.755-7.095 4.755-11.613zm-16.613-6.614c3.646 0 6.613 2.967 6.613 6.613s-2.967 6.613-6.613 6.613-6.613-2.967-6.613-6.613 2.966-6.613 6.613-6.613z",
    fill: "#4369fd"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffdbed"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170.62,
    cy: 278.962,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.08,
    cy: 278.962,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.54,
    cy: 278.962,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 278.962,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.46,
    cy: 278.962,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.92,
    cy: 278.962,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.38,
    cy: 278.962,
    r: 6.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "m387.908 80.088c-.46 0-.92-.063-1.367-.19-13.11-3.727-14.093-22.538-14.128-23.336-.101-2.271 1.344-4.325 3.516-4.998l10.5-3.252c.965-.298 1.994-.298 2.959 0l10.5 3.252c2.172.673 3.616 2.726 3.516 4.998-.035.799-1.018 19.609-14.128 23.336-.448.126-.908.19-1.368.19zm-5.008-20.215c.697 3.518 2.193 7.979 5.006 9.782 2.828-1.818 4.31-6.338 5-9.785l-4.998-1.548z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.201 434.765c-.46 0-.92-.063-1.367-.19-13.109-3.727-14.093-22.537-14.128-23.336-.101-2.271 1.344-4.325 3.516-4.998l10.5-3.252c.965-.298 1.994-.298 2.959 0l10.5 3.252c2.172.673 3.616 2.726 3.516 4.998-.035.799-1.018 19.609-14.128 23.336-.448.127-.908.19-1.368.19zm-5.007-20.215c.696 3.518 2.192 7.979 5.006 9.782 2.827-1.818 4.309-6.338 4.999-9.785l-4.998-1.548z",
    fill: "#8399fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.588 50.137c-1.279 0-2.56-.488-3.535-1.464l-5.465-5.464-5.465 5.464c-1.951 1.952-5.119 1.952-7.07 0-1.953-1.953-1.953-5.119 0-7.071l9-9c1.951-1.952 5.119-1.952 7.07 0l9 9c1.953 1.953 1.953 5.119 0 7.071-.976.976-2.256 1.464-3.535 1.464z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.852 449.097c-1.279 0-2.56-.488-3.535-1.464l-5.465-5.464-5.465 5.464c-1.951 1.952-5.119 1.952-7.07 0-1.953-1.953-1.953-5.119 0-7.071l9-9c1.951-1.952 5.119-1.952 7.07 0l9 9c1.953 1.953 1.953 5.119 0 7.071-.976.976-2.256 1.464-3.535 1.464z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.888 453.597c-1.279 0-2.56-.488-3.535-1.464l-5.465-5.464-5.465 5.464c-1.951 1.952-5.119 1.952-7.07 0-1.953-1.953-1.953-5.119 0-7.071l9-9c1.951-1.952 5.119-1.952 7.07 0l9 9c1.953 1.953 1.953 5.119 0 7.071-.976.976-2.256 1.464-3.535 1.464z",
    fill: "#ff7eb8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogin);
export default __webpack_public_path__ + "static/media/header-login.47aa5c273705edabff135d8fe17be8ec.svg";
export { ForwardRef as ReactComponent };